module.exports = __webpack_public_path__ + "static/cereal-isle-coloring-page-f5c13311df3fdc302fc83579d8dcaa98.pdf";